"use client";

import React from "react";
const partners = [{
  id: 1,
  name: "Cisco Systems",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652372/img/partner_cisco_security.png"
}, {
  id: 2,
  name: "Palo Alto Networks",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652372/img/partner_palo_alto.png"
}, {
  id: 3,
  name: "Microsoft Security",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652372/img/partner_microsoft_azure.png"
}, {
  id: 4,
  name: "ISO 27001 Certified",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652372/img/cert_iso_27001.png"
}, {
  id: 5,
  name: "Fortinet",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652372/img/partner_fortinet_gold.png"
}, {
  id: 6,
  name: "Check Point",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652372/img/partner_checkpoint_software.png"
}, {
  id: 7,
  name: "CrowdStrike",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652372/img/partner_crowdstrike.png"
}, {
  id: 8,
  name: "TÜV SÜD Security",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652372/img/cert_tuev_sued.png"
}];
export default function StrategicAlliances() {
  return <section data-section-id="224440" id="unsere-partner-zertifikate" className="bg-background text-foreground py-16 overflow-hidden border-y border-border/20">
      <style>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-marquee {
          animation: marquee 40s linear infinite;
        }
        @media (prefers-reduced-motion: reduce) {
          .animate-marquee {
            animation-play-state: paused;
          }
        }
      `}</style>

      <div className="container mx-auto px-4 md:px-6">
        <h2 className="text-center text-sm font-bold text-muted-foreground uppercase tracking-[0.2em] mb-12 font-default">
          Technologie-Partner & Zertifizierungen
        </h2>

        {}
        <div className="relative flex overflow-hidden group [mask-image:_linear-gradient(to_right,transparent_0,_black_128px,_black_calc(100%-128px),transparent_100%)]">
          
          {}
          <div className="flex w-max animate-marquee hover:[animation-play-state:paused]">
            {}
            {[...partners, ...partners].map((partner, i) => <div key={`${partner.id}-${i}`} data-index={i} className="flex items-center justify-center flex-shrink-0 px-10 md:px-16">
                <img src={partner.src} alt={partner.name} className="h-10 md:h-12 w-auto object-contain grayscale brightness-200 opacity-50 hover:grayscale-0 hover:brightness-100 hover:opacity-100 transition-all duration-500 ease-in-out cursor-pointer" loading="lazy" />
              </div>)}
          </div>
          
        </div>
      </div>
    </section>;
}